import { getFeatureStateSafe } from "./get-feature-state-safe";

import type maplibregl from "maplibre-gl";

export interface ClearActiveFeatureStateForRenderedOptions {
  sourceId: string;
  sourceLayerId?: string;
  layerId: string;
  setActiveFalse: (map: maplibregl.Map, featureId: string | number) => void;
  excludeId?: string | number;
}

/**
 * Clears the `active` feature state for all rendered features in the given layer.
 * Optionally skips a specific feature id (excludeId) when activating another.
 */
export function clearActiveFeatureStateForRendered(
  map: maplibregl.Map,
  options: ClearActiveFeatureStateForRenderedOptions,
): void {
  const { sourceId, sourceLayerId, layerId, setActiveFalse, excludeId } = options;

  if (!layerId || !map.getLayer(layerId)) {
    return;
  }

  const renderedFeatures = map
    .queryRenderedFeatures(undefined, { layers: [layerId] })
    .filter(
      (f: maplibregl.MapGeoJSONFeature) =>
        f?.id !== undefined || f?.properties?.id !== undefined,
    );

  renderedFeatures.forEach((f) => {
    const id = (f.properties?.id ?? f.id) as string | number | undefined;
    if (id == null) return;
    if (excludeId != null && String(id) === String(excludeId)) return;

    const { featureState } = getFeatureStateSafe(map, sourceId, { key: "id", value: id }, {
      sourceLayerId,
    });

    if (featureState?.active === true) {
      setActiveFalse(map, id);
    }
  });
}
